import { EmployeeBankingInformationAPIModel } from 'src/models/api.model'

export interface EmployeeState {
  bankingInfo: EmployeeBankingInformationAPIModel[]
}

export const initialEmployeeState: EmployeeState = {
  bankingInfo: undefined
}
